<template>
  <div style="width: 100vw">
    <v-layout row wrap align-center class="py-2" style="background: #4cc7e8">
      <v-flex md1></v-flex>
      <v-flex
        xs11
        md6
        class="mb-4 pb-0 pt-2"
        style="
          text-align: left;
          position: relative;
          position: relative;
          margin: auto;
        "
      >
        <p
          style="
            font-weight: bold !important;
            font-family: 'Aleo' !important;
            font-size: 30pt !important;
            color: white;
          "
          class="mb-0"
        >
          Impact Buyer Prospecting
        </p>
        <p style="color: white; position: relative; margin: auto">
          <span style="font-weight: bold">Step 1)</span> Please explore the
          Buyers that we need your help Prospecting <br />
          <span style="font-weight: bold">Step 2)</span> Fill out the
          information you can about the Buyer<br />
          <span style="font-weight: bold">Step 3)</span> We will work with the
          Buyer to generate Imapct
        </p>
      </v-flex>
      <v-flex xs12 md5 v-if="!$vuetify.breakpoint.smAndDown">
        <v-img
          :src="require('../../assets/Values/UpstreamNZ-Badge-03.png')"
          class="joinOptionCards mr-4"
          style="height: 150px; width: 150px; float: right"
          contain
        />
      </v-flex>
    </v-layout>
    <v-container grid-list-xl class="pageContent mt-4">
      <v-layout row wrap>
        <v-flex class="px-0 pt-0" style="text-align: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="ma-0 mb-4"
                v-if="hidden.havntDoneSelected"
                color="success"
                style="width: 277px"
                dark
                v-on="on"
                @click="
                  hidden.havntDoneSelected = false;
                  filterBuyers();
                "
              >
                Show {{ hidden.havntDone }} Haven't Done Buyers
              </v-btn>
              <v-btn
                @click="
                  hidden.havntDoneSelected = true;
                  filterBuyers();
                "
                color="red"
                style="width: 277px"
                class="ma-0"
                dark
                v-else
                v-on="on"
              >
                Hide Haven't Done Buyers
              </v-btn>
            </template>
            <span>Buyers are marked "Haven't Done"</span>
          </v-tooltip>
        </v-flex>
        <v-flex class="px-0 pt-0" style="text-align: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="ma-0 mb-4"
                v-if="hidden.inProcessSelected"
                color="success"
                style="width: 277px"
                dark
                v-on="on"
                @click="
                  hidden.inProcessSelected = false;
                  filterBuyers();
                "
              >
                Show {{ hidden.inProcess }} In Process Buyers
              </v-btn>
              <v-btn
                @click="
                  hidden.inProcessSelected = true;
                  filterBuyers();
                "
                color="red"
                style="width: 277px"
                class="ma-0"
                dark
                v-else
                v-on="on"
              >
                Hide In Process Buyers
              </v-btn>
            </template>
            <span>Buyers that have been marked "In Process"</span>
          </v-tooltip>
        </v-flex>
        <v-flex class="px-0 pt-0" style="text-align: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="ma-0 mb-4"
                v-if="hidden.completedSelected"
                color="success"
                style="width: 277px"
                dark
                v-on="on"
                @click="
                  hidden.completedSelected = false;
                  filterBuyers();
                "
              >
                Show {{ hidden.completed }} Completed Buyers
              </v-btn>
              <v-btn
                @click="
                  hidden.completedSelected = true;
                  filterBuyers();
                "
                color="red"
                style="width: 277px"
                class="ma-0"
                dark
                v-else
                v-on="on"
              >
                Hide Completed Buyers
              </v-btn>
            </template>
            <span>Buyers that have been marked "Completed"</span>
          </v-tooltip>
        </v-flex>
        <v-flex class="px-0 pt-0" style="text-align: center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="ma-0 mb-4"
                v-if="hidden.otherSelected"
                color="success"
                style="width: 277px"
                dark
                v-on="on"
                @click="
                  hidden.otherSelected = false;
                  filterBuyers();
                "
              >
                Show {{ hidden.other }} Other Buyers
              </v-btn>
              <v-btn
                @click="
                  hidden.otherSelected = true;
                  filterBuyers();
                "
                color="red"
                style="width: 277px"
                class="ma-0"
                dark
                v-else
                v-on="on"
              >
                Hide Other Buyers
              </v-btn>
            </template>
            <span>Buyers that have been marked "Other"</span>
          </v-tooltip>
        </v-flex>
        <v-flex
          class="mb-4"
          xs12
          v-for="(pb, index) in filteredBuyers"
          :key="index"
        >
          <div>
            <v-layout
              row
              wrap
              class="pa-3"
              style="position: relative; border: 1px solid #cccccc"
              :class="{
                HaventDone: pb.goodCauseAction == 'Haven\'t Done',
                InProcess: pb.goodCauseAction == 'In Process',
                Completed: pb.goodCauseAction == 'Completed',
                Other: pb.goodCauseAction == 'Other',
              }"
            >
              <v-flex xs12 sm4>
                <v-layout row wrap>
                  <v-flex xs12 class="pb-0">
                    <span style="font-weight: bold"> Buyer Type: </span>
                  </v-flex>
                  <v-flex xs12 class="py-0 pr-0">
                    <span style="font-size: 20pt">
                      {{ pb.impactBuyerType }}
                    </span>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <span style="font-weight: bold"> Impact Buyer: </span>
                  </v-flex>
                  <v-flex xs12 class="py-0 pr-0">
                    <span style="font-size: 20pt">
                      {{ pb.name }}
                    </span>
                  </v-flex>

                  <v-flex
                    xs12
                    style="margin-bottom: 50px"
                    class="py-0 pt-2 pr-0"
                  >
                    <span style="font-weight: bold" class="mt-4">
                      Action Notes:
                    </span>
                    <br />
                    <span style="font-size: 14pt; color: red">{{
                      pb.impactActionNotes
                    }}</span>
                  </v-flex>
                  <v-flex xs12 class="py-0 pr-0">
                    <span style="font-weight: bold">
                      Chance of Engagement:
                    </span>
                  </v-flex>
                  <v-flex xs12 class="py-0 pr-0">
                    <span style="font-size: 14pt">
                      {{ pb.impactChanceOfLead }}
                    </span>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <span style="font-weight: bold"> Interested Status: </span>
                  </v-flex>
                  <v-flex xs12 class="py-0 pr-0">
                    <span style="font-size: 14pt">
                      {{ pb.impactInterestedStatus }}
                    </span>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm5 class="pb-0">
                <v-layout row wrap>
                  <v-flex xs12 class="pb-0">
                    <span style="font-weight: bold">
                      Lead Connection Details
                    </span>
                  </v-flex>
                  <v-flex xs12 md6 class="py-0">
                    <v-text-field
                      @input="onCommentsChanged"
                      class="py-1"
                      label="Name of Contact"
                      :readonly="pb.impactLeadConnectionNameReadonly == 1"
                      :box="pb.impactLeadConnectionNameReadonly == 1"
                      v-model="pb.impactLeadConnectionName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6 class="py-0">
                    <v-text-field
                      @input="onCommentsChanged"
                      class="py-1"
                      label="Phone of Contact"
                      :readonly="pb.impactPhoneReadonly == 1"
                      :box="pb.impactPhoneReadonly == 1"
                      v-model="pb.impactPhone"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      @input="onCommentsChanged"
                      class="py-1"
                      label="Title of Contact"
                      :readonly="pb.impactLeadConnectionTitleReadonly == 1"
                      :box="pb.impactLeadConnectionTitleReadonly == 1"
                      v-model="pb.impactLeadConnectionTitle"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      @input="onCommentsChanged"
                      class="py-1"
                      label="The Connection"
                      :readonly="
                        pb.impactGoodcauseConnectionRelationReadonly == 1
                      "
                      :box="pb.impactGoodcauseConnectionRelationReadonly == 1"
                      v-model="pb.impactGoodcauseConnectionRelation"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="py-0">
                    <v-text-field
                      @input="onCommentsChanged"
                      class="py-1"
                      label="Email of Contact"
                      :readonly="pb.impactEmailReadonly == 1"
                      :box="pb.impactEmailReadonly == 1"
                      v-model="pb.impactEmail"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm3 class="mb-4 pb-4">
                <span
                  style="
                    font-weight: bold;
                    margin-right: 25px;
                    top: 0px;
                    position: relative;
                  "
                  class="mt-1"
                >
                  Your Action and Comments
                </span>
                <v-radio-group
                  class="my-0"
                  :row="!$vuetify.breakpoint.xs"
                  :column="$vuetify.breakpoint.xs"
                  @change="saveAll()"
                  v-model="pb.goodCauseAction"
                >
                  <v-radio
                    :label="`Haven't Done`"
                    value="Haven't Done"
                    color="black"
                  ></v-radio>
                  <v-radio
                    :label="`In Process`"
                    value="In Process"
                    color="black"
                  ></v-radio>
                  <v-radio
                    :label="`Completed`"
                    value="Completed"
                    color="black"
                  ></v-radio>
                  <v-radio
                    :label="`Other`"
                    value="Other"
                    color="black"
                  ></v-radio>
                </v-radio-group>
                <v-textarea
                  @input="onCommentsChanged"
                  label="Your Comments"
                  rows="7"
                  hide-detailes
                  v-model="pb.goodCauseComments"
                ></v-textarea>
                <span
                  style="
                    position: absolute;
                    bottom: 0px;
                    right: -100px;
                    width: 188px;
                    color: gray;
                  "
                  >{{ index + 1 }} of {{ filteredBuyers.length }}</span
                >
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { StripeElements } from "vue-stripe-checkout";
  import moment from "moment";

  export default {
    props: ["data"],
    components: {
      StripeElements,
    },
    watch: {
      data: function () {
        this.filterBuyers();
      },
    },
    data: () => ({
      searchDebounce: null,
      hidden: {
        otherSelected: true,
        other: 0,
        havntDoneSelected: false,
        havntDone: 0,
        inProcessSelected: true,
        inProcess: 0,
        completedSelected: true,
        completed: 0,
      },
      filteredBuyers: [],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
      }),
    },
    mounted() {
      this.filterBuyers();
    },
    methods: {
      onCommentsChanged() {
        clearTimeout(this.searchDebounce);

        this.searchDebounce = setTimeout(() => {
          this.saveAll();
        }, 1000);
      },
      saveAll() {
        let payload = {
          linkKey: this.$route.params.linkKey,
          data: this.data,
        };
        this.$store.dispatch("linkKey/saveAllProspectingBuyers", payload);
      },
      filterBuyers() {
        this.hidden.other = 0;
        this.hidden.havntDone = 0;
        this.hidden.inProcess = 0;
        this.hidden.completed = 0;

        this.filteredBuyers = this.data.filter((l) => {
          let passed = 0;

          //Interested Selected
          if (l.goodCauseAction == "Haven't Done") {
            this.hidden.havntDone += 1;
            if (this.hidden.havntDoneSelected != true) {
              return true;
            }
          } else if (this.hidden.havntDoneSelected == true) {
            passed += 1;
          }

          //No Opportunity Selected
          if (l.goodCauseAction == "In Process") {
            this.hidden.inProcess += 1;
            if (this.hidden.inProcessSelected != true) {
              return true;
            }
          } else if (this.hidden.inProcessSelected == true) {
            passed += 1;
          }

          //Future Follow Up Selected
          if (l.goodCauseAction == "Other") {
            this.hidden.other += 1;
            if (this.hidden.otherSelected != true) {
              return true;
            }
          } else if (this.hidden.otherSelected == true) {
            passed += 1;
          }

          //Already Using Selected
          if (l.goodCauseAction == "Completed") {
            this.hidden.completed += 1;
            if (this.hidden.completedSelected != true) {
              return true;
            }
          } else if (this.hidden.completedSelected == true) {
            passed += 1;
          }

          if (passed == 4) {
            return true;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .HaventDone {
    color: black;
    background: #e6e7e8;
  }

  .InProcess {
    color: black;
    background: #f6f4d2;
  }

  .Completed {
    color: black;
    background: #7acdbc;
  }

  .Other {
    color: black;
    background: #81d7ef;
  }
</style>
